import React from "react";
import SelectSearch from "react-select-search";
import Switch from "react-switch";
import CurrencyInput from "react-currency-input-field";
import DatePicker from "react-datepicker";
import { sl } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

/*React-bootstrap components */
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";

/*React-icons*/
import { BsCurrencyEuro } from "react-icons/bs";

const DeminimisAddForm = ({
  submitError,
  submitSuccess,
  isSubmitting,
  onBack,
  onSubmit,
  deminimisData,
  pomocOdobrena,
  onFieldChange,
  onPomocOdobrenaChange,
  onSelectPrejemnik,
  onSelectDajalec,
  onSelectProjekt,
  onNacrtovanaVrednostChange,
  onVisinaPomociChange,
  prejemnikDefaultOptions,
  prejemnikLockedLabel,
  dajalecDefaultOptions,
  isPrejemnikLocked,
  defaultOptions,
  fetchPrejemnikOptions,
  fetchDajalecOptions,
  fetchProjektOptions,
}) => {
  return (
    <>
      <Row className="mb-3">
        <Col>
          <Button
            variant="outline-primary"
            className="programs-button-add-text"
            onClick={onBack}
          >
            Nazaj na pregled
          </Button>
        </Col>
      </Row>

      <Form className="deminimis-form" onSubmit={onSubmit}> 
        {submitError && (
          <Row>
            <Col>
              <div className="text-danger mb-3">{submitError}</div>
            </Col>
          </Row>
        )}
        {submitSuccess && (
          <Row>
            <Col>
              <div className="text-success mb-3">{submitSuccess}</div>
            </Col>
          </Row>
        )}

        <Form.Group className="mb-3" controlId="deminimisPrejemnik">
          <Form.Label>Prejemnik pomoči</Form.Label>
          {isPrejemnikLocked ? (
            <Form.Control
              value={prejemnikLockedLabel || ""}
              readOnly
              disabled
            />
          ) : (
            <SelectSearch
              key={`prejemnik-${deminimisData.prejemnikID || "none"}-${prejemnikDefaultOptions.length}`}
              options={prejemnikDefaultOptions}
              getOptions={fetchPrejemnikOptions}
              name="prejemnikID"
              search
              debounce={300}
              placeholder="Vnesite iskalni niz"
              emptyMessage="Ni zadetkov"
              value={deminimisData.prejemnikID}
              onChange={onSelectPrejemnik}
              disabled={isPrejemnikLocked}
              autoComplete="off"
            />
          )}
        </Form.Group>

        <Form.Group className="mb-3" controlId="deminimisDajalec">
          <Form.Label>Dajalec pomoči</Form.Label>
          <SelectSearch
            options={dajalecDefaultOptions}
            getOptions={fetchDajalecOptions}
            name="dajalecID"
            search
            debounce={300}
            placeholder="Vnesite iskalni niz"
            emptyMessage="Ni zadetkov"
            value={deminimisData.dajalecID}
            onChange={onSelectDajalec}
            autoComplete="off"
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="deminimisProjekt">
          <Form.Label>Projekt</Form.Label>
          <SelectSearch
            key={`projekt-${deminimisData.prejemnikID || 'none'}`}
            options={defaultOptions}
            getOptions={fetchProjektOptions}
            name={`projektID-${deminimisData.prejemnikID || 'none'}`}
            search
            debounce={300}
            placeholder="Vnesite iskalni niz"
            emptyMessage="Ni zadetkov"
            value={deminimisData.projektID}
            onChange={onSelectProjekt}
            autoComplete="new-password"
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="deminimisDatumNacrtovanePomoci">
          <Form.Label>Datum načrtovane vrednosti pomoči</Form.Label>
          <DatePicker
            selected={deminimisData.datumNacrtovanePomoci ? new Date(deminimisData.datumNacrtovanePomoci) : null}
            onChange={(date) => {
              onFieldChange({
                target: {
                  name: "datumNacrtovanePomoci",
                  value: date ? date.toISOString().slice(0, 10) : ""
                }
              });
            }}
            dateFormat="dd. MM. yyyy"
            locale={sl}
            className="form-control"
            placeholderText="dd. mm. yyyy"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="deminimisNacrtovanaVrednost">
          <Form.Label>Načrtovana vrednost pomoči</Form.Label>
          <InputGroup>
            <CurrencyInput
              className="form-control"
              placeholder="Vnesite znesek"
              decimalScale={2}
              intlConfig={{ locale: "sl-SI", currency: "EUR" }}
              value={deminimisData.nacrtovanaVrednost}
              onValueChange={onNacrtovanaVrednostChange}
            />
            <InputGroup.Text>
              <BsCurrencyEuro />
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>

        <Row className="align-items-center mt-4 mb-3">
          <Col xs="auto">
            <Form.Label className="mb-0">Pomoč je bila odobrena</Form.Label>
          </Col>
          <Col>
            <Switch
              onChange={onPomocOdobrenaChange}
              checked={pomocOdobrena}
              className="ms-1"
            />
          </Col>
        </Row>

        {pomocOdobrena && (
          <>
            <Row>
              <Col lg={6} className="mb-3">
                <Form.Group controlId="deminimisDatumOdobritve">
                  <Form.Label>Datum odobritve pomoči</Form.Label>
                  <DatePicker
                    selected={deminimisData.datumOdobritve ? new Date(deminimisData.datumOdobritve) : null}
                    onChange={(date) => {
                      onFieldChange({
                        target: {
                          name: "datumOdobritve",
                          value: date ? date.toISOString().slice(0, 10) : ""
                        }
                      });
                    }}
                    dateFormat="dd. MM. yyyy"
                    locale={sl}
                    className="form-control"
                    placeholderText="dd. mm. yyyy"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                  />
                </Form.Group>
              </Col>
              <Col lg={6} className="mb-3">
                <Form.Group controlId="deminimisVisinaPomoci">
                  <Form.Label>Višina odobrene pomoči</Form.Label>
                  <InputGroup>
                    <CurrencyInput
                      className="form-control"
                      placeholder="Vnesite znesek"
                      decimalScale={2}
                      intlConfig={{ locale: "sl-SI", currency: "EUR" }}
                      value={deminimisData.visinaPomoci}
                      onValueChange={onVisinaPomociChange}
                    />
                    <InputGroup.Text>
                      <BsCurrencyEuro />
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3" controlId="deminimisPravnaPodlaga">
              <Form.Label>Pravna podlaga</Form.Label>
              <Form.Control
                name="pravnaPodlaga"
                as="textarea"
                rows={3}
                maxLength={500}
                placeholder="Vnesite tekst, omejitev 500 znakov"
                value={deminimisData.pravnaPodlaga}
                onChange={onFieldChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="deminimisStevilkaPriglasitve">
              <Form.Label>Številka priglasitve</Form.Label>
              <Form.Control
                name="stevilkaPriglasitve"
                type="text"
                placeholder="Vnesite številko priglasitve"
                value={deminimisData.stevilkaPriglasitve}
                onChange={onFieldChange}
              />
            </Form.Group>
          </>
        )}

        <Row>
          <Col>
            <Button
              variant="outline-primary"
              type="submit"
              className="programs-button-add-text"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Shranjujem..." : "Shrani"}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default DeminimisAddForm;